import React, { useEffect, useState } from "react";
import axios from "axios";
import { itemsPerPageValue } from "../../../utils/ItemsPerPageValue";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import ItemsPerPageSelect from "../../elements/filter/ItemsPerPageSelect";
import Notification from "../../elements/notification/Notification";
import MaterialPagination from "../../styles/materialPagination";
import CurrencyList from "./CurrencyList";
import { useHistory } from "react-router-dom";
import { checkFilterItem, fetchFilterData } from "../../../utils/fetchFilterData";
import CurrencyFilter from "./CurrencyFilter";
import FilterAppliedList from "../../elements/filter/FilterAppliedList";
import CreateCurrencyButton from "../../elements/currencies/CreateCurrencyButton";

import { StyledCurrencyWrapper } from "../styledCurrencu";

const CurrencyContainer = ({ type }) => {
  const [currency, setCurrency] = useState(null);
  const [totalPageCount, setTotalPageCount] = useState(null);

  const history = useHistory();

  const [filterData, setFilterData] = useState({
    "page": checkFilterItem(history, "page", 1, true),
    "itemsPerPage": checkFilterItem(history, "itemsPerPage", itemsPerPageValue(), true),
    "currentTab": checkFilterItem(history, "currentTab", type, false, true),
    "asset": checkFilterItem(history, "asset", null)
  });

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const fetchCurrency = () => {
    let filterUrl = fetchFilterData(filterData);
    history.replace(filterUrl);

    axios.get("/api/currencies" + filterUrl + "&type=" + type, userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        setCurrency(response.data["hydra:member"]);
        setTotalPageCount(response.data["hydra:totalPageCount"]);
      }
    }).catch(error => {
      setNotification({ ...notification, visible: true, type: "error", message: error.response.data.message });
    });
  };

  useEffect(() => {
    fetchCurrency();
  }, [filterData]);

  const onChangePage = (event, page) => {
    setFilterData({ ...filterData, page: page });
  };

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledCurrencyWrapper>
        <div className="currency-head">
          <CurrencyFilter
            filterData={filterData}
            setFilterData={setFilterData}
          />
          <ItemsPerPageSelect
            itemsPerPage={filterData.itemsPerPage}
            setItemsPerPage={(data) => setFilterData({
              ...filterData,
              "itemsPerPage": data,
              page: 1
            })}
          />
          <CreateCurrencyButton
            type={type}
            fetchCurrency={fetchCurrency}
          />
        </div>
        <FilterAppliedList
          filterData={filterData}
          setFilterData={setFilterData}
        />
        <CurrencyList currency={currency} />
        {totalPageCount > 0 &&
          <MaterialPagination
            count={totalPageCount}
            shape="rounded"
            page={filterData.page}
            onChange={(event, page) => onChangePage(event, page)}
          />}
      </StyledCurrencyWrapper>
    </>
  );
};

export default CurrencyContainer;